export const services = [
  {
    id: 'trademark',
    title: 'Trademark Registration',
    description: 'Protect your business name, logo, and slogan with professional trademark registration services designed to strengthen brand protection and secure your intellectual property. Build a stronger brand presence with confidence.',
    icon: 'Shield',
    link: '/services/trademark'
  },
  {
    id: 'copyright',
    title: 'Copyright Protection',
    description: 'Safeguard your original content, creative works, books, artwork, software, and digital assets with comprehensive copyright protection solutions that help preserve ownership and prevent unauthorized use.',
    icon: 'FileText',
    link: '/services/copyright'
  },
  {
    id: 'patent',
    title: 'Patent Services',
    description: 'Turn innovative ideas into valuable intellectual property assets. Our patent support services help inventors and businesses protect their innovations while navigating the patent application process efficiently.',
    icon: 'Lightbulb',
    link: '/services/patent'
  },
  {
    id: 'company',
    title: 'Business Formation',
    description: 'Launch your business on a strong foundation with professional company formation services. Whether you are starting an LLC, corporation, or nonprofit organization, we help streamline the setup process and support long term business growth.',
    icon: 'Building',
    link: '/services/company-formation'
  }
];

export const pricingPlans = [
  {
    id: 'essentials',
    name: 'Essentials',
    price: 49,
    popular: false,
    description: 'For first-time filers',
    features: [
      'Case Review & Assessment',
      'Basic Trademark Search',
      'USPTO Filing Assistance',
      'Trademark Monitoring (1 Month)',
      'Email Support',
      'Attorney Pre-Filing Letter',
      'Trademark Secured'
    ]
  },
  {
    id: 'standard',
    name: 'Standard',
    price: 149,
    popular: true,
    description: 'For growing businesses',
    features: [
      'Everything in Essentials',
      'Expert Case Review',
      'Comprehensive Trademark Search',
      'Trademark Monitoring (3 Months)',
      'Risk Evaluation Report',
      'Cease & Desist Template',
      'Dedicated Account Manager',
      '100% Approval Guarantee'
    ]
  },
  {
    id: 'professional',
    name: 'Professional',
    price: 299,
    popular: false,
    description: 'For established brands',
    features: [
      'Everything in Standard',
      'Attorney Review & Filing',
      '24-Hour Expedited Processing',
      'Trademark Monitoring (12 Months)',
      'Comprehensive Search (50 States)',
      'Office Action Support',
      'Opposition & Litigation Advice',
      '100% Approval Guarantee'
    ]
  },
  {
    id: 'premium',
    name: 'Premium',
    price: 899,
    popular: false,
    description: 'Maximum protection',
    features: [
      'Everything in Professional',
      'Direct Attorney Assignment',
      'Trademark Monitoring (24 Months)',
      'International Trademark Support',
      '24/7 Secure Portal Access',
      'Complete Opposition Management',
      'White Glove Service',
      '100% Approval Guarantee'
    ]
  }
];

export const lpPricingPlans = [
  {
    id: 'essentials',
    name: 'Essentials',
    price: 45,
    popular: false,
    description: 'Basic trademark filing service',
    features: [
      'Case Review',
      'Basic Trademark Search',
      'Trademark Secured',
      '24/7 Secure Online Access',
      'Cease & Desist Letter Template',
      'Free Infringement Alerts (1 Month)'
    ]
  },
  {
    id: 'enhanced',
    name: 'Enhanced',
    price: 149,
    popular: true,
    description: 'Enhanced filing with comprehensive search',
    features: [
      'Case Review by TM Expert',
      'Trademark Monitoring (3 Months)',
      '24-Hour Expedited Processing',
      'Trademark Secured',
      'Attorney Pre-Filing Letter',
      'Free Infringement Alerts (1 Month)',
      'Dedicated Client Relations Attorney'
    ]
  },
  {
    id: 'elite',
    name: 'Elite',
    price: 299,
    popular: false,
    description: 'Full legal support',
    features: [
      'Attorney Case Review & Filing',
      'Trademark Monitoring (12 Months)',
      'Direct Hit Search',
      'Refusal Risk Evaluation',
      'Comprehensive Search (50 States + Social Media/Domains)',
      'Litigant Scan',
      'Opposition & Litigation Support',
      'Dedicated Attorney',
      '100% Approval Guaranteed'
    ]
  },
  {
    id: 'exclusive',
    name: 'Exclusive',
    price: 899,
    popular: false,
    description: 'The most comprehensive trademark protection',
    features: [
      'Everything in Elite',
      'Trademark Monitoring (12 Months)',
      'Complete Paperwork Filing',
      'International Trademark Assistance',
      'Global Risk Assessment (100+ Countries)',
      'Free Infringement Alerts (3 Months)',
      'Priority Legal Support',
      '100% Approval Guarantee'
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Priya Sharma',
    role: 'Entrepreneur, Wellness Co.',
    image: 'https://images.pexels.com/photos/762020/pexels-photo-762020.jpeg',
    content: 'Their proactive trademark monitoring caught a potential conflict early on. The legal team acted fast and resolved it before it became a costly dispute. Truly invaluable for brand protection.'
  },
  {
    id: 2,
    name: 'Sarah Mitchell',
    role: 'CEO, TechNova Solutions',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHxlbnwwfHx8fDE3NjA3NjAzNTd8MA&ixlib=rb-4.1.0&q=85',
    content: 'From the initial consultation to final registration, the process was completely transparent. Their team handled every detail while we focused on building our product. Outstanding service.'
  },
  {
    id: 3,
    name: 'Marcus Johnson',
    role: 'Founder, Urban Threads Apparel',
    image: 'https://images.unsplash.com/photo-1629425733761-caae3b5f2e50?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHxlbnwwfHx8fDE3NjA3NjAzNTd8MA&ixlib=rb-4.1.0&q=85',
    content: 'Protecting my Amazon brand was non-negotiable. They managed the entire trademark process and Brand Registry enrollment flawlessly. Professional, efficient, and reasonably priced.'
  },
  {
    id: 4,
    name: 'David Chen',
    role: 'CTO, Innovate Labs',
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHxlbnwwfHx8fDE3NjA3NjAzNTd8MA&ixlib=rb-4.1.0&q=85',
    content: 'We have secured three patents with their assistance. The attorneys are deeply knowledgeable and genuinely invested in protecting our innovations. Highly recommended for any tech company.'
  },
  {
    id: 5,
    name: 'Jennifer Lopez',
    role: 'Creative Director, Artisan Collective',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw1fHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHxlbnwwfHx8fDE3NjA3NjAzNTd8MA&ixlib=rb-4.1.0&q=85',
    content: 'Copyright protection for our creative portfolio was handled with precision. From registration to enforcement strategy, their team gave us complete peace of mind to keep creating.'
  }
];

export const lpTestimonials = [
  {
    id: 1,
    name: 'Amanda R.',
    role: 'eCommerce Seller',
    content: 'The entire process was seamless. Filed within 48 hours and received approval faster than expected. Could not have been easier.'
  },
  {
    id: 2,
    name: 'Michael T.',
    role: 'Tech Startup Founder',
    content: 'Knowledgeable attorneys who handled everything from comprehensive search to final filing. The level of expertise justified every dollar.'
  },
  {
    id: 3,
    name: 'Sarah L.',
    role: 'Small Business Owner',
    content: 'Transparent pricing with no surprises. They protected my brand and walked me through Amazon Brand Registry enrollment step by step.'
  },
  {
    id: 4,
    name: 'James K.',
    role: 'Restaurant Owner',
    content: 'From concept to registered trademark, their guidance was exceptional. My restaurant brand is now fully protected at federal level.'
  },
  {
    id: 5,
    name: 'Emily W.',
    role: 'Fashion Designer',
    content: 'Fast, professional, and thorough. My fashion brand trademark was secured quickly and I have ongoing monitoring for complete protection.'
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: '98% Approval Rate',
    description: 'Industry-leading trademark approval backed by experienced IP attorneys and meticulous application preparation.',
    icon: 'Scale'
  },
  {
    id: 2,
    title: 'Licensed IP Attorneys',
    description: 'Every application reviewed and filed by USPTO-registered trademark attorneys with deep expertise in brand protection.',
    icon: 'Users'
  },
  {
    id: 3,
    title: '24-48 Hour Filing',
    description: 'Fast-track your brand protection with expedited filing and real-time application status tracking.',
    icon: 'Award'
  },
  {
    id: 4,
    title: 'Comprehensive Search',
    description: 'Thorough trademark clearance across federal databases, state records, and common law sources before filing.',
    icon: 'TrendingUp'
  }
];

export const whyChooseUsDetailed = [
  {
    id: 1,
    title: 'USPTO-Registered Attorneys',
    description: 'Licensed IP attorneys with 15+ years of federal trademark registration and brand protection experience.',
    icon: 'Briefcase'
  },
  {
    id: 2,
    title: 'Flat-Rate Pricing',
    description: 'No hidden fees. Clear trademark registration packages starting from $45 with all costs disclosed upfront.',
    icon: 'DollarSign'
  },
  {
    id: 3,
    title: 'Expedited USPTO Filing',
    description: 'Your trademark application filed with USPTO within 24-48 hours. No unnecessary delays.',
    icon: 'Zap'
  },
  {
    id: 4,
    title: 'End-to-End Protection',
    description: 'Complete support from comprehensive search through federal registration and ongoing brand monitoring.',
    icon: 'LifeBuoy'
  }
];

export const lpBenefits = [
  {
    id: 1,
    title: 'Legal Ownership',
    description: 'Prevent others from using your brand name or logo. Establish exclusive rights nationwide.',
    icon: 'Shield'
  },
  {
    id: 2,
    title: 'Brand Credibility',
    description: 'Build legal ownership and brand credibility that customers and investors trust.',
    icon: 'CheckCircle'
  },
  {
    id: 3,
    title: 'Amazon & eCommerce Protection',
    description: 'Protect your brand on Amazon, eCommerce platforms, and enroll in Amazon Brand Registry.',
    icon: 'ShoppingCart'
  },
  {
    id: 4,
    title: 'Federal Law Protection',
    description: 'Gain exclusive nationwide rights under federal law with USPTO registration.',
    icon: 'Flag'
  },
  {
    id: 5,
    title: 'Business Valuation',
    description: 'Increase your business valuation and investor confidence with registered IP assets.',
    icon: 'TrendingUp'
  },
  {
    id: 6,
    title: 'Legal Enforcement',
    description: 'Sue infringers and seek damages in federal court with registered trademark rights.',
    icon: 'Gavel'
  }
];

export const lpWhyTrust = [
  {
    id: 1,
    title: 'Experienced IP Attorneys',
    description: 'Decades of combined expertise in U.S. trademark law and intellectual property.',
    icon: 'Briefcase'
  },
  {
    id: 2,
    title: 'Fast Filing Process',
    description: 'Quick turnaround, status tracking, and 24-hour expedited options available.',
    icon: 'Clock'
  },
  {
    id: 3,
    title: 'Transparent Pricing',
    description: 'No hidden costs. Clear, upfront fees with flat-rate pricing packages.',
    icon: 'DollarSign'
  },
  {
    id: 4,
    title: 'Full Legal Support',
    description: 'From search to registration to enforcement. Complete trademark protection.',
    icon: 'Shield'
  }
];

export const howItWorks = [
  {
    id: 1,
    title: 'Free Consultation',
    description: 'Submit your brand details for a complimentary trademark evaluation. Our IP specialists assess registrability and identify potential conflicts within 24 hours.',
    icon: 'FileText'
  },
  {
    id: 2,
    title: 'Search & Attorney Review',
    description: 'We conduct an in-depth trademark search across USPTO databases, state records, and common law sources. Licensed attorneys review findings and prepare your application.',
    icon: 'CreditCard'
  },
  {
    id: 3,
    title: 'Filing & Ongoing Support',
    description: 'Your trademark application is filed with the USPTO. We provide continuous monitoring, office action responses, and expert support through registration.',
    icon: 'CheckCircle'
  }
];

export const lpProcess = [
  {
    id: 1,
    title: 'Search & Review',
    description: 'We conduct a comprehensive trademark search and review to identify potential conflicts and ensure your brand is protected.',
    icon: 'Search'
  },
  {
    id: 2,
    title: 'Prepare & File',
    description: 'Our licensed attorneys prepare and file your complete USPTO trademark application with precision.',
    icon: 'FileCheck'
  },
  {
    id: 3,
    title: 'Approval & Protection',
    description: 'Track your application progress and receive your official trademark registration certificate from the USPTO.',
    icon: 'Award'
  }
];

// Pricing Tabs V2 - Self Filing with Assistance
export const selfFilingProcessCards = [
  {
    id: 1,
    title: 'Application Preparation',
    description: 'We prepare your trademark application on the USPTO TEAS system, ensuring accurate classification, proper formatting, and compliance with USPTO requirements.',
    icon: 'FileText'
  },
  {
    id: 2,
    title: 'Identity Review and Approval',
    description: 'You securely verify your identity via ID.me and review the prepared application by our IP attorney. You’ll have the opportunity to review all details and request any revisions before submission.',
    icon: 'CheckCircle'
  },
  {
    id: 3,
    title: 'USPTO Filing',
    description: 'Once you review and approve the application, we will submit it on your behalf, ensuring all required details are accurately filed and in full compliance with official requirements of the USPTO.',
    icon: 'PaperPlane'
  }
];

// Pricing Tabs V2 - Attorney-Led Filing
export const attorneyLedProcessCards = [
  {
    id: 1,
    title: 'Information Collection',
    description: 'We collect your trademark details, including name, logo (if applicable), and a brief description of your products/services.',
    icon: 'ClipboardText'
  },
  {
    id: 2,
    title: 'Attorney Review & Application Drafting',
    description: 'Our IP attorney reviews your case, determines the appropriate trademark class(es), and prepares a strong, USPTO-compliant application.',
    icon: 'Scales'
  },
  {
    id: 3,
    title: 'Filing & Case Management',
    description: 'We file the application on your behalf and handle all procedural steps, including monitoring your application and managing any USPTO correspondence.',
    icon: 'Briefcase'
  }
];

export const selfFilingPlans = [
  {
    id: 'self-basic',
    name: 'Basic',
    price: 45,
    popular: false,
    paymentNotice: 'Easy guided process where experts support your steps and ensure correctness',
    features: ['Case Review', 'Case Filing', 'Basic Search', 'State E-Filing', 'Trademark Secured', 'Direct Hit Search', 'Dedicated Case Manager']
  },
  {
    id: 'self-deluxe',
    name: 'Deluxe',
    price: 145,
    popular: true,
    paymentNotice: 'Balanced support system helping you move forward with clear professional guidance',
    features: ['Case Review', 'Case Filing', 'Basic Search', 'State E-Filing', 'Trademark Secured', 'Direct Hit Search', 'Dedicated Case Manager', '100% Satisfaction Guarantee', 'Refusal Risk Meter']
  },
  {
    id: 'self-premium',
    name: 'Premium',
    price: 395,
    popular: false,
    paymentNotice: 'Advanced assistance structure offering deeper help planning review and ongoing clarity',
    features: ['Case Review (by a TM Expert)', 'Basic Free Trademark Search', 'State E-Filing', 'Trademark Secured', 'Direct Hit Search', 'Trademark Monitoring (3 Months)', 'Trademark Secured', 'Refusal Risk Meter', 'Complete Paperwork Filing', '100% Satisfaction Guarantee']
  },
  {
    id: 'self-elite',
    name: 'Elite',
    price: 595,
    popular: false,
    paymentNotice: 'Premium guided experience with expert leadership attention and complete confidence',
    features: ['Case Review (by a TM Expert)', 'Basic Free Trademark Search', 'State E-Filing', 'Assigned Case Filing Officer', 'Private Registration', 'Trademark Secured', 'Federal Search & Clearance (All States)', 'Federal E-Filing (USPTO)', 'Cease & Desist Letter', 'Same Day Filing', 'Trademark Monitoring (1 Year)', 'Direct Hit Search', 'Dedicated Case Manager', '24/7 Secure Online Access', '100% Approval Guarantee']
  }
];

export const attorneyLedPlans = [
  {
    id: 'attorney-basic',
    name: 'Basic',
    price: 795,
    popular: false,
    paymentNotice: 'Simple reliable service guided by professionals for smooth easy completion process',
    features: ['Attorney-Handled Trademark Filing from Start to Finish', 'Professional Case Evaluation', 'Application Preparation & Submission', 'Preliminary Trademark Search']
  },
  {
    id: 'attorney-deluxe',
    name: 'Deluxe',
    price: 895,
    popular: true,
    paymentNotice: 'Better guided experience with added care support and improved overall confidence',
    features: ['Attorney-Led Trademark Filing', 'End-to-End Case Handling', 'Comprehensive Case Review & Analysis', 'Professional Application Preparation', 'Trademark Secured']
  },
  {
    id: 'attorney-premium',
    name: 'Premium',
    price: 1145,
    popular: false,
    paymentNotice: 'Strong structured service with expert attention enhanced handling and steady progress',
    features: ['Attorney-Led Case Review', 'Complete Case Filing & Management', 'Advanced Direct-Hit Trademark Search', 'Trademark Monitoring & Alerts']
  },
  {
    id: 'attorney-elite',
    name: 'Elite',
    price: 1545,
    popular: false,
    govtFeeIncluded: true,
    paymentNotice: 'Premium priority service with highest focus care speed and complete assurance',
    features: ['Attorney-Led Case Review & Strategy', 'Complete Case Filing & Management', 'Federal & State Trademark Search Report', 'Trademark Monitoring & Real-Time Alerts']
  }
];
